import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Paper).attrs({
  elevation: 3,
})`
  width: 100%;
`;
